import React, { useEffect, useState } from "react";
import Heading from "../Highlightedheading/Heading";
import BasicTextFields from "../textfield/textField";
import toast, { Toaster } from "react-hot-toast";
import Button from "../Buttons/Button";
import Joi from "joi";
import axios from "axios";
import config from "../../config/config";

const Contact = () => {
  const [formValues, setFormValues] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const contactSchema = Joi.object({
    fullName: Joi.string()
      .pattern(/^[a-zA-Z\s]+$/)
      .required()
      .label("Name"),

    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .label("Email"),

    phoneNumber: Joi.string()
      .pattern(/^[0-9]{10}$/)
      .required()
      .label("Contact Number"),

    message: Joi.string().allow("").optional(),
  });

  const [errors, setErrors] = useState({});

  const validateForm = (values) => {
    const { error } = contactSchema.validate(values, config.joiOptions);

    if (!error) return {};

    const newErrors = {};

    error.details.forEach((err) => {
      const label = err.context?.label || err.path[0];

      if (err.type === "string.empty" || err.type === "any.required") {
        newErrors[err.path[0]] = `${label} is required`;
      } else {
        newErrors[err.path[0]] = `Enter a valid ${label}`;
      }
    });

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({ ...formValues, [name]: value });

    // clear error for that field
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // prevent double submit

    const validationErrors = validateForm(formValues);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true); // lock the form
      try {
        await axios.post(`${config.apiUrl}/contact-leads`, {
          name: formValues.fullName,
          email: formValues.email,
          phone: formValues.phoneNumber,
          message: formValues.message,
        });

        toast.success("Form submitted successfully!");

        setFormValues({
          fullName: "",
          email: "",
          phoneNumber: "",
          message: "",
        });
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
      } finally {
        setIsSubmitting(false); // unlock after done
      }
    }
  };

  return (
    <div className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] rounded-lg w-full h-full flex flex-col font-montserrat font-light text-white relative ">
      <Toaster position="top-right" />
      <div>
        <Heading
          headingText={"CONTACT US"}
          className="text-center md:text-left"
        />
      </div>

      <form onSubmit={handleSubmit} className="space-y-6 md:space-y-16">
        <div
          // data-aos="fade-up"
          className="flex flex-col space-y-6  md:flex-row text-[0.83vw] md:text-[1.25vw] justify-between items-center md:gap-10 md:space-y-0 md:space-x-4"
        >
          <div className="w-full">
            <BasicTextFields
              name="fullName"
              value={formValues.fullName}
              onChange={handleChange}
              text="Name*"
            />
            {errors.fullName && (
              <p className="text-red-500 text-[3.5vw] md:text-[1.1vw] p-1">
                {errors.fullName}
              </p>
            )}
          </div>
          <div className="w-full">
            <BasicTextFields
              name="email"
              value={formValues.email}
              onChange={handleChange}
              text="Email Id*"
            />
            {errors.email && (
              <p className="text-red-500 text-[3.5vw] md:text-[1.1vw] p-2">
                {errors.email}
              </p>
            )}
          </div>
          <div className="w-full">
            <BasicTextFields
              name="phoneNumber"
              value={formValues.phoneNumber}
              onChange={handleChange}
              text="Contact No*"
              inputModeNumeric={true}
            />
            {errors.phoneNumber && (
              <p className="text-red-500 text-[3.5vw] md:text-[1.1vw] p-1">
                {errors.phoneNumber}
              </p>
            )}
          </div>
        </div>
        <div
          // data-aos="fade-up"
          className="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-28"
        >
          <div className="w-full space-y-6">
            <BasicTextFields
              name="message"
              value={formValues.message}
              onChange={handleChange}
              text="Message"
              fullWidth={true}
            />
            {/* {errors.message && (
              <p className="text-red-500 text-md p-1">{errors.message}</p>
            )} */}
          </div>
          <Button
            buttonText={isSubmitting ? "Submitting..." : "Submit"}
            customCss={"pt-[2vh] pl-2"}
            disabled={isSubmitting}
          />
        </div>
      </form>
    </div>
  );
};

export default Contact;
